// src/services/role.service.ts
import axios from 'axios';
import authHeader from './auth-header';
import { API_URL } from '../config/api.config';
import { Role, RolePermission } from '../interfaces/Role';

// Get all available roles
const getAllRoles = async (): Promise<Role[]> => {
  try {
    console.log('Fetching roles');
    console.log('API URL:', `${API_URL}/roles`);
    console.log('Auth headers:', authHeader());
    
    const response = await axios.get(`${API_URL}/roles`, { 
      headers: authHeader()
    });
    
    console.log('Role data response:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('Error fetching roles:', error);
    
    // Return fallback roles from the database dump provided
    return [
      {
        role_id: 1,
        title: 'user',
        description: 'user account',
        created_at: '2025-05-07 13:53:38',
        updated_at: '2025-05-07 13:53:38'
      },      {
        role_id: 2,
        title: 'admin',
        description: 'Regular admin who handles authorized complaints in assigned categories',
        created_at: '2025-05-07 13:54:31',
        updated_at: '2025-05-07 13:54:31'
      },
      {
        role_id: 3,
        title: 'system_incharge',
        description: 'Network admin who assigns categories to admins and manages the system',
        created_at: '2025-05-10 05:11:41',
        updated_at: '2025-05-10 05:11:41'
      },      {
        role_id: 4,
        title: 'developer',
        description: 'System developer with technical access',
        created_at: '2025-05-10 05:12:01',
        updated_at: '2025-05-10 05:12:01'
      },
      {
        role_id: 5,
        title: 'super_admin',
        description: 'Highest level admin who can authorize complaints and has full system access',
        created_at: '2025-05-10 05:12:01',
        updated_at: '2025-05-10 05:12:01'
      }
    ];
  }
};

// Get a specific role by ID
const getRoleById = async (roleId: number): Promise<Role> => {
  try {
    const response = await axios.get(`${API_URL}/roles/${roleId}`, { 
      headers: authHeader()
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to fetch role details' };
  }
};

// Get role permissions
const getRolePermissions = async (roleId: number) => {
  try {
    const response = await axios.get(`${API_URL}/roles/${roleId}/permissions`, { 
      headers: authHeader()
    });
    return response.data;
  } catch (error: any) {
    throw error.response?.data || { message: 'Failed to fetch role permissions' };
  }
};

const RoleService = {
  getAllRoles,
  getRoleById,
  getRolePermissions
};

export default RoleService;
